import { DynamicIndexObjectType, IOTV_Notifiable_EventType, MapLike } from '@iotv/iotv-v3-types'
import { AlertIncidentType, Severity } from '../Incidents/enums'
import { IncidentStatus } from '../Incidents/IncidentTypes'
import { ModelCommon } from '../ModelCommon'
import { SubscribedStatus } from './enums'
import { INotificationSubscription, NotificationDeliveryConfig, SubscribedStatusUnion, getNotificationSubscriptionDSK } from './NotificationTypes'

const typeName = 'NotificationSubscription'

export class NotificationSubscription extends ModelCommon implements INotificationSubscription, DynamicIndexObjectType {
  // pk either user or self

  // dpk === NotificationSubscription
  // dsk === Incident or other grouping hash

  constructor({ ...ob }: MapLike<any>) {
    super(typeName, ob)
    this.incidentProducingTypeId = ob.incidentProducingTypeId
    this.incidentEntityOrGroupingSk = ob.incidentEntityOrGroupingSk
    this.incidentEntityOrGroupingName = ob.incidentEntityOrGroupingName
    this.incidentInitiatorSk = ob.incidentInitiatorSk
    this.filter = ob.filter ?? { severities: [], statuses: [] }
    if (ob.filter?.severities) this.filter.severities = ob.filter.severities
    if (ob.filter?.statuses) this.filter.statuses = ob.filter.statuses
    if (ob.filter?.onActions) this.filter.onActions = ob.filter.onActions
    this.subscriptionState = ob.subscriptionState ?? { status: SubscribedStatus.ACTIVE }
    this.deliveryPreferences = ob.deliveryPreferences ?? []
    this.incidentType = ob.incidentType
    this.incidentSubtype = ob.incidentSubtype

    this.updateDynamicKeys()
  }

  updateDynamicKeys() {
    const { incidentEntityOrGroupingSk, incidentType, incidentSubtype, incidentInitiatorSk } = this
    this.dsk = getNotificationSubscriptionDSK({ incidentEntityOrGroupingSk, incidentType, incidentSubtype, incidentInitiatorSk })

    this.dpk = this.type
  }

  dpk: string | undefined
  dsk: string | undefined

  incidentProducingTypeId: string
  incidentEntityOrGroupingSk: string
  incidentEntityOrGroupingName: string
  incidentType: AlertIncidentType | undefined
  incidentSubtype: string | undefined
  incidentInitiatorSk: string | undefined

  filter: {
    severities: Severity[]
    statuses: IncidentStatus[]
    onActions: IOTV_Notifiable_EventType[]
  }

  subscriptionState: SubscribedStatusUnion

  deliveryPreferences: NotificationDeliveryConfig[]
}
